import { Avatar, Col, Row, Tabs, TabsProps } from 'antd';
import ProfessionalSummary from '../../../components/Professional/Summary';
import ProfessionalAnalyses from '../../../components/Analyses/Mobile';
import ProfessionalQuestionnaire from '../../../components/Questionnaire/Mobile';
import { ClientAvatarContainer, ClientCardsContainer, MobileContainer, MobileProfessionalDetailsContainer } from './style';
import { UserOutlined } from '@ant-design/icons';
import Analyses from '../../../components/Analyses';
import Questionnaire from '../../../components/Questionnaire';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { useGetProfessionalClient } from '../../../hooks/professionals/useProfessionalClient';
import CustomLoading from '../../../components/Common/Loading';

const Dashboard = () => {
  const { user } = useSelector((state: RootState) => state.auth);
  const { data: client, loading } = useGetProfessionalClient(user?.id as string);
  const tabItemStyle = {
    padding: 20,
    height: '100%',
    overflow: 'auto',
    paddingBottom: 100
  };

  const items: TabsProps['items'] = [
    {
      key: '1',
      label: 'Summary',
      children: <ProfessionalSummary />,
      style: tabItemStyle
    },
    {
      key: '2',
      label: 'Analyses',
      children: <ProfessionalAnalyses />,
      style: tabItemStyle
    },
    {
      key: '3',
      label: 'Questionnaires',
      children: <ProfessionalQuestionnaire client={client} questionnaireAssignments={client?.questionnaireAssignments} />,
      style: tabItemStyle
    },
  ];

  if (loading) return <CustomLoading />;

  return (
    <>
      <ClientCardsContainer>
        <ClientAvatarContainer>
          <Avatar
            style={{ backgroundColor: '#e2e8f0' }}
            size={{ xs: 134, sm: 134, md: 134, lg: 134, xl: 134, xxl: 134 }}
            icon={<UserOutlined />}
          />
        </ClientAvatarContainer>
        <Row gutter={20}>
          <Col span={12}>
            <Analyses />
          </Col>
          <Col span={12}>
            <Questionnaire client={client} questionnaireAssignments={client?.questionnaireAssignments} />
          </Col>
        </Row>
      </ClientCardsContainer>
      <MobileContainer>
        <MobileProfessionalDetailsContainer>
          <Avatar
            size={{ xs: 146, sm: 146, md: 146, lg: 0, xl: 0, xxl: 0 }}
          />
          <h2>Hello, {user?.firstName} {user?.familyName}</h2>
        </MobileProfessionalDetailsContainer>
        <Tabs
          tabBarStyle={{
            boxShadow: '1px 1px 1px 0px #0000001A'
          }}
          tabBarGutter={50}
          defaultActiveKey="1"
          items={items}
          centered={true} style={{
            marginBottom: '5rem',
          }}
        />
      </MobileContainer>
    </>
  );
}

export default Dashboard;